import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { gql } from "__generated__/gql";
import client from "../../apollo";
import { ApplicationLanguagesQuery } from "__generated__/graphql";
import { SelectProps } from "@cofano/cck/Select/Select";
import { ChildPropsFromArray } from "types/commons";

export type ApplicationLanguageSelectOption = ChildPropsFromArray<ApplicationLanguagesQuery, "languages">;

const ApplicationLanguageSelect = ({ value, ...rest }: Omit<
	SelectProps<ApplicationLanguageSelectOption, false>,
	"fetchOptions" | "paginated" | "multiple" | "getOptionLabel" | "loadingLabel" | "disableSearch"
>) => {

	const onFetchOptions = async () => {
		try {
			const result = await client.query({
				query: GET_APPLICATION_LANGUAGES_QUERY,
			});

			return {
				options: result.data.languages,
				totalResults: result.data.languages.length,
			};
		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptions}
			paginated
			loadingLabel={intl.formatMessage({ id: "LOADING_DATA" })}
			getOptionLabel={option => option.description}
			value={value}
			multiple={false}
			disableSearch
		/>
	);
};

export const GET_APPLICATION_LANGUAGES_QUERY = gql(`#graphql
	query applicationLanguages {
		languages(onlyApplicationLanguage: true) {
			id
			code
			description
		}
	}
`);

export default ApplicationLanguageSelect;
